Selectize.define('remove_cross', function (options) {
    const escape_html = function (str) {
        return (`${str}`)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    options = $.extend({
        label: '✕',
        title: 'Remove',
        className: 'M-localitySelect__itemRemove',
        append: true,
    }, options);

    /**
     * Appends an element as a child (with raw HTML).
     *
     * @param {string} html_container
     * @param {string} html_element
     * @return {string}
     */
    const append = function (html_container, html_element) {
        // USE SAME FUNCTION IN SINGLE_CLOSE AND MULTI_CLOSE
        const pos = html_container.search(/(<\/[^>]+>\s*)$/);
        return html_container.substring(0, pos) + html_element + html_container.substring(pos);
    };

    const singleClose = function (thisRef) {
        options.className = 'M-localitySelect__singleItemRemove';

        const self = thisRef;
        const html = `<a href="javascript:void(0)" class="${options.className}" tabindex="-1" title="${escape_html(options.title)}">${options.label}</a>`;

        thisRef.setup = (function () {
            const original = self.setup;
            return function (...args) {
                // override the item rendering method to add the button to each
                if (options.append) {
                    const render_item = self.settings.render.item;
                    self.settings.render.item = function (...args2) {
                        return append(render_item.apply(thisRef, args2), html);
                    };
                }

                original.apply(thisRef, args);

                // add event listener
                thisRef.$control.on('click', `.${options.className}`, (e) => {
                    e.preventDefault();
                    if (self.isLocked) {
                        return;
                    }

                    self.clear();
                });
            };
        }());
    };

    const multiClose = function (thisRef) {
        const self = thisRef;
        const html = `<a href="javascript:void(0)" class="${options.className}" tabindex="-1" title="${escape_html(options.title)}">${options.label}</a>`;

        thisRef.setup = (function () {
            const original = self.setup;
            return function (...args) {
                // override the item rendering method to add the button to each
                if (options.append) {
                    const render_item = self.settings.render.item;
                    self.settings.render.item = function (...args2) {
                        return append(render_item.apply(thisRef, args2), html);
                    };
                }

                original.apply(thisRef, args);

                // add event listener
                thisRef.$control.on('click', `.${options.className}`, (e) => {
                    e.preventDefault();
                    if (self.isLocked) {
                        return;
                    }

                    const $item = $(e.currentTarget).parent();
                    self.setActiveItem($item);
                    if (self.deleteSelection()) {
                        self.setCaret(self.items.length);
                    }
                });
            };
        }());
    };

    if (this.settings.mode === 'single') {
        singleClose(this);
    } else {
        multiClose(this);
    }
});

Selectize.define('remote_search', function () {
    const self = this;

    self.onKeyUp = (function () {
        return function (e) {
            if (self.isLocked) return e && e.preventDefault();
            const value = this.$control_input.val() || '';
            if (self.lastValue !== value) {
                self.lastValue = value;
                self.onSearchChange(value);
                // self.refreshOptions(); // Prevent filtering in JS. Wait for request to complete
                self.trigger('type', value);
            }
            return true;
        };
    }());

    self.onSearchChange = (function () {
        return function (value) {
            const fn = self.settings.load;
            if (!fn) return;
            // if (self.loadedSearches.hasOwnProperty(value)) return; // Do not store results of requests
            // self.loadedSearches[value] = true;
            self.load((callback) => {
                fn.apply(self, [value, function (results) {
                    self.clearOptions(); // Clear current options before adding new ones

                    if (self.$control_input.val() !== '') { // Ignore response if search query is empty now
                        callback(results);
                    }
                }]);
            });
        };
    }());
});

Selectize.define('locality_confirm', function () {
    const originalOnOptionSelect = this.onOptionSelect;
    this.onOptionSelect = (function () {
        return function (...args) {
            const thisOptions = {...this.options};
            // const thisItems = {...this.items};
            if (this.customLocality) {
                const data = $(`#${Bingo.Map.ClearLocalitiesConfirmModalId}`).data();
                Bingo.Bootstrap.Confirmation.show({
                    ...data,
                    onConfirm: () => {
                        this.options = thisOptions;
                        originalOnOptionSelect.apply(this, args);
                    },
                });
            } else {
                originalOnOptionSelect.apply(this, args);
            }
        };
    }());
});

LocalitySelectize = (
    elementId,
    language,
    autoSubmit = true,
    localitiesPreload,
    originPage,
    trans,
    localityTypesJson,
) => {
    const LOCALITY_SEARCH_URL = `/${language}/api/v1/search/locality`;
    const element = $(`#${elementId}`);

    const DROPDOWN_COUNT_WRAP_CLASS_NAME = 'M-localitySelect__count';
    const DROPDOWN_HEADER_CLASS_NAME = 'M-localitySelect__dropdownHeader';
    const DROPDOWN_COUNT_CLASS_NAME = 'M-localitySelect__countText';
    const DROPDOWN_CUSTOM_COUNT_CLASS_NAME = 'M-localitySelect__customCountText';
    const DROPDOWN_COUNT_CLEAR_CLASS_NAME = 'M-localitySelect__countRemove';
    const DROPDOWN_NO_RESULTS_CLASS_NAME = 'M-localitySelect__noResults';

    let initialLoad = true;
    let localities = [];

    if (typeof localitiesPreload !== 'undefined' && localitiesPreload !== null) {
        localities = JSON.parse(localitiesPreload);
    }
    const localityTypes = JSON.parse(localityTypesJson);

    Selectize.define('no_results', function (options) {
        const self = this;

        options = $.extend({
            message: trans.no_results,

            html(data) {
                return (
                    `<div class="selectize-dropdown ${data.classNames}">`
                    + '<div class="selectize-dropdown-content">'
                    + `<div class="${DROPDOWN_NO_RESULTS_CLASS_NAME}">${data.message}</div>`
                    + '</div>'
                    + '</div>'
                );
            },
        }, options);

        self.displayEmptyResultsMessage = function () {
            this.$empty_results_container.css('top', this.$control.outerHeight());
            this.$empty_results_container.css('width', this.$control.outerWidth());
            this.$empty_results_container.show();
            this.$control.addClass('dropdown-active');
        };

        self.onKeyDown = (function () {
            const original = self.onKeyDown;

            return function (...args) {
                const e = args[0] || undefined;
                original.apply(self, args);
                if (e.keyCode === 27) {
                    this.$empty_results_container.hide();
                }
            };
        }());

        self.onBlur = (function () {
            const original = self.onBlur;

            return function (...args) {
                original.apply(self, args);
                this.$empty_results_container.hide();
                this.$control.removeClass('dropdown-active');
            };
        }());

        self.setup = (function () {
            const original = self.setup;
            return function (...args) {
                original.apply(self, args);
                self.$empty_results_container = $(options.html($.extend({
                    classNames: self.$input.attr('class'),
                }, options)));
                self.$empty_results_container.insertBefore(self.$dropdown);
                self.$empty_results_container.hide();
            };
        }());
    });


    const init = () => {
        element.selectize({
            persist: true,
            plugins: ['remote_search', 'remove_cross', 'locality_confirm', 'no_results'],
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            optgroupField: 'location_type',
            optgroupLabelField: 'label',
            optgroupValueField: 'value',
            lockOptgroupOrder: true,
            loadThrottle: null,
            create: false,
            optgroups: localityTypes,
            preload: true,
            options: localities,
            render: {
                item(item) {
                    return `<div title="${item.name}" class="A-tag -outlined M-localitySelect__item"><div class="M-localitySelect__itemInner">${item.name}</div></div>`;
                },
                option(item) {
                    if (typeof item.item_name !== 'undefined') {
                        return `<div class="M-localitySelect__option">${item.item_name}</div>`;
                    }
                    return `<div class="M-localitySelect__option">${item.name}</div>`;
                },
            },
            load(query, callback) {
                populateOptions(query, callback);
            },
            onType() {
                if (this.$control_input.val() === '') {
                    this.clearOptions();
                    this.close();
                }
            },
            onChange() {
                this.clearOptions();
                this.close();

                populateItemsToDropdown(this);

                if (this.items.length === 0) {
                    this.$dropdown_header[0].innerHTML = null;
                    deleteDropdownCount(this);
                }
            },
            onFocus() {
                this.$dropdown_header.removeClass('d-none');
            },
            onBlur() {
                // needs timeout, blur happens before click. This allows to keep it open for selected delete
                setTimeout(
                    () => {
                        if (!this.skipBlur) {
                            this.$dropdown_header.addClass('d-none');
                        }
                        this.skipBlur = false;
                    },
                    300,
                );

                //  if u type something and click out of element, then parent .A-textField loses -labelUp
                //  this prevents it
                if (this.items.length > 0 || this.customLocality) {
                    this.$wrapper.closest('.A-textField')
                        .addClass('-labelUp');
                }
                this.clearOptions();
            },
            onInitialize() {
                this.skipBlur = false;
                this.customLocalities = 0;
                this.customLocality = false;
                this.getMapInstance = () => getMapInstance();
                this.autoSubmit = autoSubmit; // needs to be here.Is accessed also in map
                this.setCustomLocalities = () => {
                    this.customLocality = true;
                    deleteDropdownCount(this);
                    createDropdownCount(this);
                    this.$dropdown_count.find(`.${DROPDOWN_CUSTOM_COUNT_CLASS_NAME}`)[0].innerHTML = trans.custom_locality;

                    this.$wrapper.closest('.A-textField')
                        .addClass('-labelUp');
                };

                this.removeCustomLocalities = (unsetMap) => {
                    if (this.customLocality) {
                        if (typeof unsetMap === 'undefined') {
                            unsetMap = true;
                        }
                        deleteDropdownCount(this);
                        this.clearOptions();

                        this.$wrapper.closest('.A-textField')
                            .removeClass('-labelUp');
                        const map = this.getMapInstance();
                        if (unsetMap && map && this.autoSubmit) {
                            map.unsetDrawings();
                            map.unsetActiveTool();
                            map.unsetLastActiveTool();
                            map.setDrawingModeNone();
                        }

                        this.customLocality = false;
                        this.showInput();
                    }
                };

                this.$control_input[0].type = 'text';
                this.$control_input.addClass('M-localitySelect__input no-live-validation');

                this.$dropdown.closest('.selectize-control')
                    .addClass('M-localitySelect')
                    .find('.items').addClass('M-localitySelect__items');

                if (this.items.length > 0) {
                    createDropdownCount(this);
                }

                this.$dropdown.addClass('M-localitySelect__dropdown');
                this.$dropdown_content.addClass('M-localitySelect__options');

                //  new div, used for displaying selected items under input
                const dropdownHeader = document.createElement('div');
                dropdownHeader.className = DROPDOWN_HEADER_CLASS_NAME;
                this.$dropdown[0].parentElement.insertBefore(dropdownHeader, this.$dropdown[0]);
                this.$dropdown_header = $(`.${DROPDOWN_HEADER_CLASS_NAME}`);

                populateItemsToDropdown(this);
                this.$dropdown_header.addClass('d-none');
                this.close();

                // Workaround: when input is lock allow to clear value anyway.
                this.$control.off('click', '.M-localitySelect__singleItemRemove');
                this.$control.on('click', '.M-localitySelect__singleItemRemove', (e) => {
                    e.preventDefault();
                    this.clear();
                });

                element.on('change', () => {
                    onChange();
                });

                onChange();
            },
            score(search) {
                const score = this.getScoreFunction(search);
                return function (item) {
                    if (typeof item.is_always_visible !== 'undefined' && item.is_always_visible === true) {
                        return true;
                    }
                    return score(item);
                };
            },
        });
    };

    const getMapInstance = () => {
        let map = false;

        switch (originPage) {
            case Bingo.Map.ORIGIN_PAGE_MODE.DEMAND:
                map = Bingo.Map.getInstance('new-demand-map');
                break;
            case Bingo.Map.ORIGIN_PAGE_MODE.OFFER_LIST:
                map = Bingo.Map.getInstance('offer-search-map');
                break;
            default:
                break;
        }

        return map;
    };

    const populateItemsToDropdown = (selectize) => {
        if (selectize.customLocality) {
            selectize.removeCustomLocalities();
        }
        const itemsEl = selectize.$wrapper.find('.M-localitySelect__item');

        if (itemsEl.length > 0) {
            createDropdownCount(selectize);
            //  fill in locality count
            selectize.$dropdown_count.find(`.${DROPDOWN_COUNT_CLASS_NAME}`)[0].innerHTML = itemsEl.length > 0
                ? `${itemsEl.length} ${itemsEl.length === 1 ? trans.locality : trans.localities}`
                : '';
        } else {
            deleteDropdownCount(selectize);
        }

        //  copy selected items to new structure under input
        itemsEl.each((i) => {
            selectize.$dropdown_header[0].appendChild(itemsEl[i]);
        });

        //  reattach remove functionality on copied items
        selectize.$wrapper.find('.M-localitySelect__item .M-localitySelect__itemRemove').each(function () {
            this.addEventListener('click', (event) => {
                const itemId = event.target.parentElement.getAttribute('data-value');
                const itemEl = $(`[data-value="${itemId}"]`);
                selectize.skipBlur = true;
                selectize.removeItem(itemEl, false);
                selectize.$control_input[0].focus();
                selectize.$dropdown_header.removeClass('d-none');
            });
        });
    };

    const createDropdownCount = (selectize) => {
        if (!selectize.$dropdown_count) {
            //  create div for locality count and all clear button
            const dropdownCount = document.createElement('div');
            dropdownCount.className = DROPDOWN_COUNT_WRAP_CLASS_NAME;
            dropdownCount.innerHTML = `<span class="${DROPDOWN_CUSTOM_COUNT_CLASS_NAME}"></span>`;
            dropdownCount.innerHTML += `<span class="${DROPDOWN_COUNT_CLASS_NAME}"></span>`;
            dropdownCount.innerHTML += `<span class="${DROPDOWN_COUNT_CLEAR_CLASS_NAME}">✕</span>`;
            selectize.$control_input[0].parentElement.insertBefore(dropdownCount, $('.M-localitySelect__input')[0]);
            selectize.$dropdown_count = $(`.${DROPDOWN_COUNT_WRAP_CLASS_NAME}`);
            selectize.$dropdown_count.addClass('A-tag -outlined');

            selectize.$dropdown_count.on('click', `.${DROPDOWN_COUNT_CLEAR_CLASS_NAME}`, () => {
                selectize.clear(false);
                selectize.removeCustomLocalities();
                onChange();
            });
        }
    };

    const deleteDropdownCount = (selectize) => {
        if (selectize.$dropdown_count) {
            selectize.$dropdown_count.remove();
            delete selectize.$dropdown_count;
        }
    };

    const onChange = () => {
        const selectize = element[0].selectize;

        let map = null;
        if (selectize.autoSubmit) {
            if (!initialLoad) {
                switch (originPage) {
                    case Bingo.Map.ORIGIN_PAGE_MODE.DEMAND:
                        map = Bingo.Map.getInstance('new-demand-map');
                        map.processLocalitiesFromInput();
                        break;
                    case Bingo.Map.ORIGIN_PAGE_MODE.OFFER_LIST:
                    default:
                        triggerOfferSearchForm(element.closest('form'));
                        break;
                }
            }
        }
    };

    const populateOptions = (query, callback) => {
        const data = {
            localityName: query,
        };

        // first load sets something up. That's why there is empty load for first one.
        if (initialLoad || query.length === 0) {
            initialLoad = false;
            callback();
        } else {
            const settings = {
                type: 'GET',
                url: LOCALITY_SEARCH_URL,
                data,
                disableSpinner: true,
                off: ['unique'],
                success(returnData) {
                    const selectize = element[0].selectize;
                    callback(returnData.data.data);
                    if (returnData.data.data.length < 1) {
                        selectize.close();
                    }
                    if (typeof selectize.displayEmptyResultsMessage !== 'undefined') {
                        if (returnData.data.noResultsFound) {
                            selectize.displayEmptyResultsMessage();
                        } else {
                            selectize.$empty_results_container.hide();
                        }
                    }
                },
            };
            $.nette.ajax(settings);
        }
    };

    init();
};
